import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, FormControl, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { DefaultRequest } from '../requests/default.request';
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import { MessengerModule } from '../messenger/module';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { addCookie, getCookieValue } from '../tools/cookie-code';

/**
 * 订单码校验弹窗
 */
class EncryptModal extends React.Component<Props, State> {
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.checkOrderCode = this.checkOrderCode.bind(this);
        this.editOrderPassword = this.editOrderPassword.bind(this);
        this.cancelOrderCode = this.cancelOrderCode.bind(this);
    };
    public state: State = {
        // 登录用户
        employee_id: '',
        password_id: '',
        // 是否重置密码
        isResetPassword: false,
        // 是否明文密码
        showPassword: false,
        // 订单加密码
        orderCode: '',
        // 订单加密模态框
        encryptConfirm: false
    }

    // *********************
    // 生命周期
    // *********************
    UNSAFE_componentWillMount() {
    }
    componentDidMount() {
        // 初始执行一遍校验临时码
        this.init();
    }


    // *********************
    // 方法区
    // *********************

    /**
     * 检查订单状态
     * - 如果在审核中， 不需要显示校验密码弹窗
     * - 如果审核已通过，并且密码不为空，需要显示校验弹窗
     */
    public async init() {
        let { orderTab } = this.props;
        if (this.props.approvalStatus === 'REVIEW' || this.props.approvalStatus === 'REJECTED') {
            this.setState({ encryptConfirm: false });
            return;
        };
        // 初始化获取订单id 先判断传过来的值,没有则在获取缓存的值
        let orderID = orderTab.orderId ? orderTab.orderId : getCacheField('orderTab.orderId');
        let ORDER_CODE = getCookieValue('orderCode') === '' ? '' : JSON.parse(getCookieValue('orderCode'));
        const ORDER_ID = getCookieValue('orderId') === '' ? '' : JSON.parse(getCookieValue('orderId'));
        // 如果记录orderID 跟当前的id不一致
        if (ORDER_ID !== orderID) ORDER_CODE = '';
        const checkRes = await DefaultRequest.getOrderPassword(orderID, `${ORDER_CODE}`);
        switch (checkRes.status) {
            // 验证成功
            case 200:
                addCookie('orderId', orderID, 3600);
                addCookie('orderCode', ORDER_CODE, 3600);
                this.setState({
                    encryptConfirm: false
                })
                break;
            // 验证失败
            case 300:

                const failCheckRes = await DefaultRequest.getOrderPassword(orderID, '');
                if (failCheckRes.status === 200) {
                    this.setState({
                        encryptConfirm: false
                    })
                } else {
                    this.setState({
                        encryptConfirm: true
                    })
                }
                break;
            // 订单码不存在
            default:
                this.setState({ encryptConfirm: false })
                break;
        }
    }

    /**
     * 校验订单密码
     * @returns 
     */
    public async checkOrderCode() {
        const { orderTab } = this.props;
        if (!this.state.orderCode) return;
        // 开台密码校验
        const checkRes = await DefaultRequest.getOrderPassword(orderTab.orderId, this.state.orderCode);
        switch (checkRes.status) {
            case 200:
                // 通过存储订单码和订单ID 来区分临时密码框的显示判断
                addCookie('orderCode', this.state.orderCode, 3600);
                addCookie('orderId', orderTab.orderId, 3600);
                this.setState({
                    encryptConfirm: false
                })
                break;
            case 300:
                this.messengerModule.say({
                    message: `${i18n.t('auto_open_page_incorrect_pin')}`,
                    level: "Error",
                });
                break;
            default:

                break;
        }
    }

    /**
     * 修改订单临时密码
     */
    public async editOrderPassword() {
        const { orderTab } = this.props;
        if (this.state.orderCode === '') return;
        const editRes = await DefaultRequest.editOrderPassword(
            this.state.employee_id,
            this.state.password_id,
            orderTab.orderId,
            this.state.orderCode
        );
        switch (editRes.status) {
            case 200:
                this.messengerModule.say({
                    message: `${i18n.t('auto_open_page_modification_succeed')}`,
                    level: "Success",
                });
                this.setState({
                    employee_id: '',
                    password_id: '',
                    isResetPassword: false,
                })
                break;
            case 300:
                this.messengerModule.say({
                    message: `${i18n.t('auto_open_page_modification_failed')}`,
                    level: "Error",
                });
                break;
            default:
                break;
        }
    }

    /**
     * 废除临时密码
     */
    public async cancelOrderCode() {
        if (!this.state.employee_id || !this.state.password_id) return;
        const editRes = await DefaultRequest.editOrderPassword(
            this.state.employee_id,
            this.state.password_id,
            getCacheField('orderTab.orderId'),
            ''
        );
        if (editRes.status === 200) {
            this.messengerModule.say({
                message: `${i18n.t('auto_open_page_modification_succeed')}`,
                level: "Success",
            });
            this.setState({
                encryptConfirm: false
            })
        } else {
            this.messengerModule.say({
                message: `${i18n.t('auto_open_page_modification_failed')}`,
                level: "Error",
            });
        }
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { employee_id, password_id, showPassword, orderCode, encryptConfirm } = this.state;
        const checkCode = /^\d{4}$/.test(orderCode);
        return (
            <Dialog
                className="orderCodeDialog"
                open={encryptConfirm}
                aria-labelledby="form-dialog-title">

                {/* 重置密码 */}
                {
                    this.state.isResetPassword ?
                        <React.Fragment>
                            <DialogContent>
                                <DialogContentText>{i18n.t('auto_open_page_text_reset_temporary_password')}</DialogContentText>
                                <FormControl variant="outlined">
                                    <TextField
                                        required
                                        type={'text'}
                                        id="outlined-margin-normal"
                                        label={i18n.t('auto_open_page_employee_account')}
                                        margin="normal"
                                        variant="outlined"
                                        value={employee_id}
                                        onChange={(event) => {
                                            this.setState({ employee_id: event.target.value });
                                        }}
                                    />
                                    <TextField
                                        required
                                        type={'password'}
                                        label={i18n.t('auto_open_page_employee_password')}
                                        id="outlined-margin-normal"
                                        margin="normal"
                                        variant="outlined"
                                        value={password_id}
                                        onChange={(event) => {
                                            this.setState({ password_id: event.target.value });
                                        }}
                                    />
                                    <TextField
                                        type={showPassword ? 'text' : 'password'}
                                        label={i18n.t('auto_open_page_pin')}
                                        id="outlined-margin-normal"
                                        helperText={checkCode || orderCode === '' ? '' : `${i18n.t('auto_open_page_text_input_password')}`}
                                        margin="normal"
                                        variant="outlined"
                                        value={orderCode}
                                        onChange={(event) => {
                                            this.setState({ orderCode: event.target.value });
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                        onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault()}
                                                    >
                                                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </DialogContent>

                            <DialogActions>
                                <Button onClick={() => {
                                    this.setState({ isResetPassword: false })
                                }} color="primary">
                                    {i18n.t('auto_open_page_text_go_back')}
                                </Button>
                                <Button onClick={() => {
                                    if (checkCode) this.editOrderPassword();
                                }} color="primary">
                                    {i18n.t('auto_open_page_text_confirm_changes')}
                                </Button>

                            </DialogActions>
                            <DialogActions>
                                <Button onClick={this.cancelOrderCode} color="primary">
                                    {i18n.t('auto_open_page_text_cancel_temporary_password')}
                                </Button>
                            </DialogActions>

                        </React.Fragment>
                        :
                        // 输入密码
                        <React.Fragment>
                            {/* <DialogTitle id="form-dialog-title">订单码</DialogTitle> */}
                            <DialogContent>
                                <DialogContentText>{i18n.t('auto_open_page_text_input_temporary_password')}</DialogContentText>

                                <TextField
                                    autoFocus
                                    label={i18n.t('auto_open_page_pin')}
                                    type={showPassword ? 'text' : 'password'}
                                    value={orderCode}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={(event) => {
                                        this.setState({ orderCode: event.target.value });
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                    onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault()}
                                                >
                                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    this.setState({ isResetPassword: true })
                                }} color="primary">
                                    {i18n.t('auto_open_page_text_forgot_password')}
                                </Button>
                                <Button onClick={this.checkOrderCode} color="primary">
                                    {i18n.t('auto_open_page_button_confirm')}
                                </Button>
                            </DialogActions>
                        </React.Fragment>
                }

                {/* 输入密码 */}

            </Dialog >
        )
    }
}

export default withSnackbar(EncryptModal)
// *********************
// State & Prop类型
// *********************

type State = {
    // 是否重置密码
    isResetPassword: boolean;
    // 登录用户
    employee_id: string;
    password_id: string;
    // 是否明文密码
    showPassword: boolean;
    // 订单加密码
    orderCode: string;
    // 是否显示订单加密模态框
    encryptConfirm: boolean;
}

type Props = {
    // 订单信息
    orderTab: {
        // 开台人数
        person: number;
        // 订单Id
        orderId: number;
        // 菜单信息
        menuList: {
            // id
            main_group_id: number,
            // name
            main_group_name: string,
        };
        // 扫码id
        customer: string;
        // 开台具体人数
        childNum: number,
        normalNum: number,
        otherNum?:number;
    }
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED',
    updateLocalState: (val: Record<string, unknown>) => void;
} & WithSnackbarProps
